import Card from "./Card";
import classes from "./MealItems.module.css";
import ChickenChowmein from "../assests/ChickenChowmein.png";
import wagges from "../assests/wagges.png";
import UniqueFriedRicewithMasalaFriedChicken from "../assests/UniqueFriedRicewithMasalaFriedChicken.png";
import ChickenWhiteSaucePasta from "../assests/ChickenWhiteSaucePasta.png";
import VegetableFriedRicewithRedChiliChicken from "../assests/VegetableFriedRicewithRedChiliChicken.png";

const MealsList = () => {
  return (
    <section>
      <Card>
        <ul>
          <div>
            <h3>Vegetable Fried Rice with Red Chili Chicken</h3>
            <div className={classes.description}>
              Healthy vegetable fried rice with spicy red sauce chili chicken
              served with our tastebud triggering sauce. Perfect combination for
              healthy and delicious.
            </div>
            <div className={classes.price}>220 BDT only</div>
            <div className={classes["meal-image"]}>
              <img src={VegetableFriedRicewithRedChiliChicken} />
            </div>
          </div>

          <div>
            <h3>Potato Wedges</h3>
            <div className={classes.description}>
              Crispy and spicy potato wedges, served with our flavorous sauce.
            </div>
            <div className={classes.price}>80 BDT only</div>
            <div className={classes["meal-image"]}>
              <img src={wagges} />
            </div>
          </div>

          <div>
            <h3>Chicken Chow mein</h3>
            <div className={classes.description}>
              Mouth-watering chicken chow mein. Served with our taste bud
              triggering sauce.
            </div>
            <div className={classes.price}>180 BDT only</div>
            <div className={classes["meal-image"]}>
              <img src={ChickenChowmein} />
            </div>
          </div>

          <div>
            <h3>Chicken White Sauce Pasta</h3>
            <div className={classes.description}>
              Chezzy white sauce pasta, composed of chicken and capsicum.
              Excellently combined to serve your delight.
            </div>
            <div className={classes.price}>350 BDT only</div>
            <div className={classes["meal-image"]}>
              <img src={ChickenWhiteSaucePasta} />
            </div>
          </div>

          <div>
            <h3>Unique Fried Rice with Masala Fried Chicken</h3>
            <div className={classes.description}>
              Unique fried rice, consisting of both chicken and vegetables,
              served with hot and spicy masala fried chicken and sauces.
              Combined to satisfy your appetite.
            </div>
            <div className={classes.price}>220 BDT only</div>
            <div className={classes["meal-image"]}>
              <img src={UniqueFriedRicewithMasalaFriedChicken} />
            </div>
          </div>
        </ul>
      </Card>
    </section>
  );
};
export default MealsList;
